export const USERS_LIST_KEY = 'users-list';
export const ROLES_LIST_KEY = 'roles-list';
export const EXTERNAL_USER_KEY = 'external-user';
